module.exports = __webpack_public_path__ + "static/media/b1.714d9eb.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xubin/b1.mp3
// module id = mc9S
// module chunks = 0